import type { Market, OnboardingStep, Sex } from "@ferrivia/api-contract";

export type Step = "intro" | OnboardingStep;

// The male branch never sees the life-stage question, and the US asks for a
// name instead of an email (OTP already verified the address).
export function stepsFor(market: Market, sex: Sex | null, knowsBirthYear: boolean): Step[] {
  const questions: Step[] = knowsBirthYear ? ["sex"] : ["sex", "age"];
  if (sex === "female") questions.push("life_stage");
  return market === "us"
    ? ["intro", "name", ...questions, "location", "consents"]
    : ["intro", ...questions, "location", "email", "consents"];
}
